module.exports = __webpack_public_path__ + "img/cert-img.2bcd6123.png";